import React from "react";
import nl2br from "@/shared/nl2br";
import { createAttributeHeightFix } from "../image";

const Template1 = (props) => {
  const { src, width, height } = createAttributeHeightFix(
    420,
    props.image_path,
    props.items.image.images[0] ?? {},
  );

  return (
    <div className="popup-box">
      <div className="popup-box__figure">
        <img
          className="popup-box__figure-img"
          src={src}
          width={width}
          height={height}
          alt={props.items.heading.text}
        />
      </div>
      <div className="popup-box__body">
        <p
          className="popup-box__heading font-family--middle"
          style={{ color: props.items.heading.color }}
        >
          {props.items.heading.text}
        </p>
        <p
          className="popup-box__text"
          style={{ color: props.items.text.color }}
        >
          {nl2br(props.items.text.text)}
        </p>
        <a
          className="action-btn--submit font-family--middle"
          href={props.items.button.url}
          style={{
            color: props.items.button.color,
            backgroundColor: props.items.button.background,
            borderColor: props.items.button.background,
          }}
          onClick={(e) => {
            /** @see https://github.com/wdpk-plus-creation/webtk/blob/develop/resources/assets/js/admin/common_preview.js#L1 */
            if (!window?.preview) {
              props.handleTrackingCt(e);
            }
          }}
        >
          {props.items.button.text}
        </a>
      </div>
      <button className="popup-box__close" onClick={props.handleClose} />
    </div>
  );
};

export default Template1;
